import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-[75vh] flex items-center justify-center py-20 technical-grid">
      <SEO title="403 - Adgang nægtet" />

      <div className="max-w-xl mx-auto px-4 text-center space-y-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-amber-950/70 border border-amber-500/40 text-amber-400 font-open-sans text-xs uppercase tracking-wider">
          <i className="fa-solid fa-lock" aria-hidden="true" />
          <span>Fejl 403</span>
        </div>

        <h1 className="font-display text-4xl sm:text-6xl font-extrabold text-white tracking-tight">
          Adgang nægtet
        </h1>

        <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side eller ressource. Hvis du mener dette er en fejl, kontakt venligst JARCon ApS.
        </p>

        <div className="pt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-lg bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
          >
            Tilbage til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-slate-200 border border-slate-700 text-xs font-open-sans transition-all"
          >
            Kontakt JARCon
          </Link>
        </div>
      </div>
    </div>
  );
}
